<template>
    <div class="hotel-list">

        <div class="main-container">
            <div class="rule">
                <div class="main-container-head">
                    <ul class="breadcrumb">
                        <li @click="routetokPage('/')"><a href="javascript:void(0)">酒店预订</a>></li>
                        <li>{{CityName}}{{ProductType=='256'?'民宿':'酒店'}}</li>
                        <!-- <li>香港置地文华东方酒店</li> -->
                    </ul>
                </div>
                <div class="main-left list" id="mapAndHistory">
                    <!-- 条件搜索组件 -->
                    <SearchBox :CheckIn="CheckIn" :CheckOut="CheckOut" :keys="key" :AdultCount="AdultCount"
                               :ChildrenCount="ChildrenCount" :RoomCount="RoomCount" :ChildrenAges="ChildrenAges"
                               :ProductType="ProductType" @selectCity="selectCity" @selectHotel="selectHotel"
                               @selectLandmark="selectLandmark" :isFloat="mapAndHistoryFixed"
                               @calendarSelect="calendarSelect" @selectRoomCount="selectRoomCount"
                               @selectRoomPeopelNum="selectRoomPeopelNum" :Country='Country' @selectCountry="selectCountry"
                               @submit="changeFilter" >

                    </SearchBox>
                    <div class="cnhotel-main-filter">
                        <div class="cnhotel-filter-loca">
                            <div class="filter-loca-left pull-left">
                                <label>位置</label>
                            </div>
                            <div class="filter-loca-right pull-left">
                                <div class="filter-loca-top">
                                    <div :class="LgActive===''?'select-btn select-btn-all ':'select-btn'"
                                         @click="selectThisLandmark('')">不限
                                    </div>

                                    <div :class="LgActive===idx?'select-btn  active':'select-btn'" @click="LgActive=idx"
                                         v-for="(item,idx) in LandmarkGroups">
                                        <span>{{item.GroupName}}</span><i class="triangle"></i>
                                    </div>
                                    <div class="filter-loca-list" v-for="(item,idx) in LandmarkGroups"
                                         v-show="idx===LgActive">
                                        <ul>
                                            <li v-for="lm in item.Landmarks" :class="lm.ID==LandmarkCode?'active':''"
                                                @click="selectThisLandmark(lm)"><a
                                                    href="javascript:void(0)">{{lm.Name}}</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="cnhotel-filter-loca" v-if="From==1">
                            <div class="filter-loca-left pull-left">
                                <label>价格</label>
                            </div>
                            <div class="filter-loca-right pull-left">
                                <div class="filter-loca-top list-star-value">
                                    <label :class="PriceMin==''&&PriceMax==''?'active':''"
                                           @click="PriceMin='';PriceMax=''">不限</label>
                                    <label :class="PriceMax===150?'active':''"
                                           @click="PriceMin=0;PriceMax=150">150元以下</label>
                                    <label :class="PriceMin==150?'active':''" @click="PriceMin=150;PriceMax=300">150-300元</label>
                                    <label :class="PriceMin==300?'active':''" @click="PriceMin=300;PriceMax=600">300-600元</label>
                                    <label :class="PriceMin==600?'active':''" @click="PriceMin=600;PriceMax=1000">600-1000元</label>
                                    <label :class="PriceMin==1000?'active':''" @click="PriceMin=1000;PriceMax=''">1000元以上</label>
                                </div>
                            </div>
                        </div>
                        <div class="cnhotel-filter-loca">
                            <div class="filter-loca-left pull-left">
                                <label>星级</label>
                            </div>
                            <div class="filter-loca-right pull-left list-star-value">
                                <label :class="Star==''?'active':''" @click="Star=''">不限</label>
                                <label :class="Star==5?'active':''" @click="Star=5">
                                    <input type="checkbox" :checked="Star==5"/>
                                    五星/豪华
                                </label>
                                <label :class="Star==3?'active':''" @click="Star=3">
                                    <input type="checkbox" :checked="Star==3"/>
                                    四星高档
                                </label>
                                <label :class="Star==2?'active':''" @click="Star=2">
                                    <input type="checkbox" :checked="Star==2"/>
                                    三星舒适
                                </label>
                                <label :class="Star=='0,1'?'active':''" @click="Star='0,1'">
                                    <input type="checkbox" :checked="Star=='0,1'"/>
                                    二星及以下
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="cnhotel-list-content">
                        <div class="cnhotel-list-content-in">
                            <div class="cnhotel-list-top">
                                <div class="pull-left">
                                    <div :class="Sort==0?'cnhotel-list-sort active':'cnhotel-list-sort' " @click="Sort=0">
                                        欢迎度排序
                                    </div>
                                    <div :class="Sort==4?'cnhotel-list-sort active':'cnhotel-list-sort' " @click="Sort=4">好评优先
                                    </div>

                                    <div :class="Sort==1||Sort==2?'cnhotel-list-sort active':'cnhotel-list-sort'"
                                         @mouseover="priceBoxShow=true" @mouseout="priceBoxShow=false" v-if="From==1">
                                        <div class="box" v-show="priceBoxShow">
                                            <p class="active" @click="Sort=1;priceText=priceText1" v-html="priceText1"></p>
                                            <p @click="Sort=2;priceText=priceText2" v-html="priceText2"></p>
                                        </div>


                                        <span v-show="Sort==1">价格   低<i class="iconfont icon-qianjin"></i>高</span>
                                        <span v-show="Sort==2">价格   高<i class="iconfont icon-qianjin"></i>低</span>
                                        <span v-show="Sort!=1&&Sort!=2">价格 </span>

                                        <!-- <span v-html="priceText"></span> -->
                                        <i class="triangle-a"></i>
                                    </div>

                                    <div :class="Sort==5||Sort==6?'cnhotel-list-sort active':'cnhotel-list-sort'"
                                         @mouseover="starBoxShow=true" @mouseout="starBoxShow=false">
                                        <div class="box" v-show="starBoxShow">
                                            <p class="active" @click="Sort=5">星级 高<i class="iconfont icon-qianjin"></i>低</p>
                                            <p @click="Sort=6">星级 低<i class="iconfont icon-qianjin"></i>高</p>
                                        </div>
                                        <span v-show="Sort==5">星级 高<i class="iconfont icon-qianjin"></i>低</span>
                                        <span v-show="Sort==6">星级 高<i class="iconfont icon-qianjin"></i>低</span>
                                        <span v-show="Sort!=5&&Sort!=6">星级 </span>
                                        <i class="triangle"></i>
                                    </div>

                                    <div :class="Sort==7||Sort==8||Sort==9?'cnhotel-list-sort active':'cnhotel-list-sort'"
                                         @mouseover="discountBoxShow=true" @mouseout="discountBoxShow=false" v-if="From==1">
                                        <div class="box" v-show="discountBoxShow">
                                            <p class="active" @click="Sort=8">早鸟优惠</p>
                                            <p @click="Sort=7">连住优惠</p>
                                            <p @click="Sort=9" >团房优惠</p>
                                        </div>
                                        <span v-show="Sort==8">早鸟优惠</span>
                                        <span v-show="Sort==7">连住优惠</span>
                                        <span v-show="Sort==9" >团房优惠</span>
                                        <span v-show="Sort!=7&&Sort!=8&&Sort!=9">优惠 </span>
                                        <i class="triangle"></i>
                                    </div>

                                </div>
                                <div class="pull-right">
                                    <div class="cnhotel-filter-result">
                                        为您搜到
                                        <span class="color-orange">{{total}}</span>
                                        家酒店
                                    </div>
                                </div>
                            </div>
                            <div class="textCenter mgsie" v-if="!list">
                                当前城市暂无可预订的酒店！
                            </div>

                            <div class="hotel-content hotel-shadow " v-for="(item,index) in list" :ref="item.ID"
                                 :data-name="item.HotelName" :data-lat="item.Lat" :data-lng="item.Lon" :data-id="item.ID"
                                 style="position:relative">

                                <div :class="From==0?'hotel-box bordBot':'hotel-box'">

                                    <h3 @click="routeToDetails(item)">
                                        <i class="num">{{index+1}}</i>
                                        {{item.HotelName}}
                                        <span v-if="item.HotelEName&&(item.HotelName!=item.HotelEName)">({{item.HotelEName}})</span>
                                        <span>({{item.ID}})</span>
                                    </h3>
                                    <div class="hotel-body">
                                        <div class="hotel-img">
                                            <div class="hotel-sell-box">
                                                <i v-if="item.RecommendLevel==1" class="sell-i-word">主推</i>
                                                <i v-if="item.RecommendLevel==2" class="sell-i-word">特推</i>
                                            </div>
                                            <div class="img-left hotel-img-big">
                                                <img src="./../../assets/img/defaultHotel.jpg" v-if="!item.Pics||!item.Pics[0]">
                                                <ImgLoader :defaultImgUrl="'./../../assets/img/defaultHotel.jpg'"
                                                           :imgUrl="item.Pics[0].Url|replaceImgSrc(3)" v-else/>
                                            </div>
                                            <div class="img-right">
                                                <div class="sub-img">
                                                    <img src="./../../assets/img/defaultHotel.jpg"
                                                         v-if="!item.Pics||!item.Pics[1]">
                                                    <ImgLoader :defaultImgUrl="'./../../assets/img/defaultHotel.png'"
                                                               :imgUrl="item.Pics[1].Url|replaceImgSrc(3)" v-else/>
                                                </div>
                                                <div class="sub-img">
                                                    <img src="./../../assets/img/defaultHotel.jpg"
                                                         v-if="!item.Pics||!item.Pics[2]">
                                                    <ImgLoader :defaultImgUrl="'./../../assets/img/defaultHotel.png'"
                                                               :imgUrl="item.Pics[2].Url|replaceImgSrc(3)" v-else/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="hotel-info">
                                            <div class="star">
                                                <i class="iconfont icon-unie641" v-if="item.Star>=0"></i>
                                                <i class="iconfont icon-unie641" v-if="item.Star>=2"></i>
                                                <i class="iconfont icon-unie641" v-if="item.Star>=4"></i>
                                                <i class="iconfont icon-unie641" v-if="item.Star>=6"></i>
                                                <i class="iconfont icon-unie641" v-if="item.Star>=8"></i>
                                                <i class="iconfont icon-unie641" v-if="item.Star>=10"></i>
                                                <i class="iconfont icon-unie641" v-if="item.Star>=12"></i>
                                                <i class="iconfont icon-unie641" v-if="item.Star>=14"></i>
                                                <i class="iconfont icon-unie641 half" v-if="'135791113'.indexOf(item.Star)>-1"></i>
                                            </div>
                                            <div class="address-a" v-show="From==0">
                                                <span><i class="iconfont icon-lmy-chengshi"></i>{{item.LocationCN}}</span>
                                            </div>
                                            <p class="address">
                                                <a href="javascript:void(0)">{{item.DistrictName}}</a>
                                                <span v-if="item.DistrictName">| </span>{{item.Address}}
                                                <!--<span class="score"><span>
                                                {{item.Evaluation}} {{item.CommRate}}</span>/5分</span>-->
                                            </p>
                                            <div class="hotel-labels">
                                                <div class="label-item" v-if="(item.Attr & 1)==1">连住优惠</div>
                                                <div class="label-item" v-if="(item.Attr & 2)==2">早鸟优惠</div>
                                                <div class="label-item" v-if="(item.Attr & 4)==4" >团房优惠</div>
                                            </div>
                                            <div class="hotel-fac">
                                                <!-- 1, 6,7,8,9,30,32,44,47,50,55,56,68,70,76,78,100,99 -->

                                                <i :class="'iconfont icon-f-'+key" v-for="(eqmt,key) in item.Facilities">
                                                    <!-- <i class="iconfont icon-check " v-if="!isIconExist(key)"></i> -->
                                                    {{eqmt}}
                                                </i>
                                            </div>
                                        </div>
                                        <div class="hotel-score">
                                            <div class="score" v-if="From==1||item.LowestPrice>0">
                                                <CanvasScore :score="item.CommRate" :id="item.ID"></CanvasScore>

                                                <div class="total-score-a">
                                                    <p class="one">{{item.Evaluation}}</p>
                                                    <p class="two">总分5分</p>
                                                </div>
                                            </div>

                                            <div class="score-a" v-else>
                                                <div class="score-a">
                                                    <img src="../../assets/img/star/1.0.png" alt="" v-if="item.CommRate==1"/>
                                                    <img src="../../assets/img/star/1.5.png" alt="" v-if="item.CommRate==1.5"/>
                                                    <img src="../../assets/img/star/2.0.png" alt="" v-if="item.CommRate==2"/>
                                                    <img src="../../assets/img/star/2.5.png" alt="" v-if="item.CommRate==2.5"/>
                                                    <img src="../../assets/img/star/3.0.png" alt="" v-if="item.CommRate==3"/>
                                                    <img src="../../assets/img/star/3.5.png" alt="" v-if="item.CommRate==3.5"/>
                                                    <img src="../../assets/img/star/4.0.png" alt="" v-if="item.CommRate==4"/>
                                                    <img src="../../assets/img/star/4.5.png" alt="" v-if="item.CommRate==4.5"/>
                                                    <img src="../../assets/img/star/5.0.png" alt="" v-if="item.CommRate==5"/>
                                                </div>
                                                <div class="score-b">
                                                    <p>
                                                        <span class="one">{{item.Evaluation}} {{item.CommRate}}</span>
                                                        <span class="two">/5分</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="price" v-if="From==1&&item.LowestPrice>0">
                                                {{Currency}} <span>{{item.LowestPrice}}</span> 起
                                            </div>
                                            <div class="price" v-if="From==1&&item.LowestPrice==-1">售罄</div>

                                            <div class="check-detail" @click="routeToDetails(item)">查看详情 →</div>
                                        </div>
                                    </div>
                                </div>
                                <!--国内酒店-->
                                <table class="hotel-table" v-if="item.tables&&From==1">
                                    <thead>
                                    <tr>
                                        <th width="20%">房型</th>
                                        <th class="a-left" width="20%">子产品</th>
                                        <th width="10%">入住人</th>
                                        <th width="10%">政策</th>
                                        <th width="13%">剩余库存</th>
                                        <th width="15%">均价/间/晚</th>
                                        <th width="12%">操作</th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="!item.tables">
                                    <tr>
                                        <td colspan="7">
                                            <Loading :isLoading="item&&item.isRoomLoading"></Loading>
                                        </td>
                                    </tr>
                                    </tbody>
                                    <tbody v-for="(room,idx) in item.tables" v-else-if="item.tables">
                                    <tr v-for="(price,index) in room.Prices" @click="book(item,room,price)"
                                        v-show="item.isShowAllRooms">
                                        <td class="v-top" :rowspan="room.Prices.length" v-if="index==0">
                                            <div class="room-type">{{room.RoomName}}</div>
                                            <div class="detail-btn">查看详情</div>
                                        </td>
                                        <td class="a-left">{{price.RPName}}</td>
                                        <td>
                                            <i class="iconfont icon-yonghu" v-if="price.MaxPerson>0"></i>
                                            <i class="iconfont icon-yonghu" v-if="price.MaxPerson>1"></i>
                                            <i class="iconfont icon-yonghu" v-if="price.MaxPerson>2"></i>
                                        </td>
                                        <td>
                                            <div class="line cursorPoint" @mouseover="openPolicyShow(price)"
                                                 @mouseout="openPolicyShow(price)">
                                                <span>{{price.CanCancel?'可取消':'不可取消'}}</span>
                                                <div class="line-modal" v-show="price.isPolicyShow">{{price.CancelPolicy}}</div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="line " v-if="price.Stock>=5&&price.Tip!=6">
                                                房量充足
                                            </div>
                                            <div class="line lower-alert " v-if="price.Stock<5&&price.Stock>0&&price.Tip!=6">
                                                <span>仅剩<label>{{price.Stock}}</label>间</span>
                                            </div>
                                            <div class="line" v-if="price.Tip==6"><span>售罄</span></div>
                                        </td>
                                        <td @mouseover="openRoomShow(price)" @mouseout="openRoomShow(price)">
                                            <div class="not-cancel" v-show="price.DailyRates.length!=1">均{{price.AvgPrice}}
                                            </div>
                                            <div class="not-cancel" v-show="price.DailyRates.length==1">
                                                <span>{{price.AvgPrice}}</span></div>
                                            <div class="confirm"><span>总价￥{{price.AdultPrice}}</span></div>
                                            <div class="remain my-list-zindex-hack" v-show="price.roomShow">
                                                <div class="remain-modal">
                                                    <table class="remain-table">
                                                        <thead>
                                                        <tr>
                                                            <td style="width:135px;">日期</td>
                                                            <td style="width:85px;">库存</td>
                                                            <td style="width:125px;">房价/间/晚</td>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="rate in price.DailyRates">
                                                            <td>{{rate.Date|dateToYMDline}}</td>
                                                            <td>
                                                                <span class="little" v-show="rate.Stock">仅剩{{rate.Stock}}间</span>
                                                                <span class="little" v-show="!rate.Stock">售罄</span>
                                                            </td>
                                                            <td><span class="price">{{Currency}}{{rate.AdultPrice}}</span></td>
                                                        </tr>

                                                        <tr>
                                                            <td colspan="3">总价：
                                                                <span class="price">￥{{price.AdultPrice}}</span>
                                                                (
                                                                {{RoomCount}}
                                                                间{{price.DailyRates.length}}晚
                                                                )
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div :class="price.Tip==1||price.Tip==0?'confirm-btn':'confirm-btn disabled'">预订
                                            </div>
                                            <div class="remain">
                                                <label v-if="price.Tip==0">立即确认</label>

                                                <label v-if="price.Tip==1&&dateToday==CheckIn">0.5小时内确认</label>
                                                <label v-if="price.Tip==1&&dateToday!=CheckIn">1小时内确认</label>

                                                <label v-if="price.Tip==3">需提前</label>
                                                <label v-if="price.Tip==4">需连住</label>
                                                <label v-if="price.Tip==5">{{room.MiniRoomCount}}间以上</label>
                                                <label v-if="price.Tip==6">售罄</label>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                                <!--境外酒店-->
                                <table class="hotel-table" v-if="item.tables&&From==0">
                                    <thead>
                                    <tr>
                                        <th width="20%">房型</th>
                                        <th class="a-left" width="13%">子产品</th>
                                        <th width="10%">入住人</th>
                                        <th width="10%">政策</th>
                                        <th width="12%">剩余库存</th>
                                        <th width="15%">均价/间/晚</th>
                                        <th width="10%">操作</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(price,index) in item.tables" @click="frbook(item,price)"
                                        v-if="price.DailyRates">
                                        <td class="v-top">
                                            <div class="room-type">{{price.RoomName}}</div>
                                            <div class="detail-btn">查看详情</div>
                                        </td>
                                        <td class="a-left">{{price.RPName}}</td>
                                        <td>
                                            <i class="iconfont icon-yonghu" v-if="price.MaxPerson>0"></i>
                                            <i class="iconfont icon-yonghu" v-if="price.MaxPerson>1"></i>
                                            <i class="iconfont icon-yonghu" v-if="price.MaxPerson>2"></i>
                                        </td>
                                        <td>
                                            <div class="line cursorPoint" @mouseover="openPolicyShow(price)"
                                                 @mouseout="openPolicyShow(price)">
                                                {{price.CanCancel?'可取消':'不可取消'}}
                                                <div class="line-modal" v-show="price.isPolicyShow">{{price.CancelPolicy}}</div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="line " v-if="price.Stock>=5&&price.Tip!=6">
                                                房量充足
                                            </div>
                                            <div class="line " v-if="price.Stock<5&&price.Stock>0&&price.Tip!=6">
                                                仅剩<label>{{price.Stock}}</label>间
                                            </div>
                                            <div class="line" v-if="price.Tip==6">售罄</div>
                                        </td>
                                        <td @mouseover="openRoomShow(price)" @mouseout="openRoomShow(price)">
                                            <div class="not-cancel" v-show="price.DailyRates.length!=1"><span>均{{price.AvgPrice}}</span>
                                            </div>
                                            <div class="not-cancel" v-show="price.DailyRates.length==1">{{price.AvgPrice}}</div>
                                            <div class="confirm">总价￥{{price.Price}}</div>
                                            <div class="remain" v-show="price.roomShow">
                                                <div class="remain-modal">
                                                    <table class="remain-table">
                                                        <thead>
                                                        <tr>
                                                            <td style="width:135px;">日期</td>
                                                            <td style="width:85px;">库存</td>
                                                            <td style="width:125px;">房价/间/晚</td>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="rate in price.DailyRates">
                                                            <td>{{rate.Date|dateToYMDline}}</td>
                                                            <td>
                                                        <span class="little"
                                                              v-show="rate.Stock">仅剩{{rate.Stock}}间</span>
                                                                <span class="little" v-show="!rate.Stock">售罄</span>
                                                            </td>
                                                            <td><span class="price">{{Currency}}{{rate.AdultPrice}}</span></td>
                                                        </tr>

                                                        <tr>
                                                            <td colspan="3">总价：
                                                                <span class="price">￥{{price.Price}}</span>
                                                                (
                                                                {{RoomCount}}
                                                                间{{price.DailyRates.length}}晚
                                                                )
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div :class="price.Tip==1||price.Tip==0?'confirm-btn':'confirm-btn disabled'">预订</div>
                                            <div class="remain">
                                                <label v-if="price.Tip==0">立即确认</label>

                                                <label v-if="price.Tip==1&&dateToday==CheckIn">0.5小时内确认</label>
                                                <label v-if="price.Tip==1&&dateToday!=CheckIn">1小时内确认</label>

                                                <label v-if="price.Tip==3">需提前</label>
                                                <label v-if="price.Tip==4">需连住</label>
                                                <label v-if="price.Tip==5">{{room.MiniRoomCount}}间以上</label>
                                                <label v-if="price.Tip==6">售罄</label>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                                <!--<div class="check-more" @click="loadTables(item)" v-if="From==1">-->
                                    <!--{{item.isShowAllRooms?'收起全部房型':'展开全部房型'}}-->
                                    <!--<i class="iconfont icon-xiala " v-show="!item.isShowAllRooms"></i>-->
                                    <!--<i class="iconfont icon-xiala close" v-show="item.isShowAllRooms"></i>-->
                                <!--</div>-->
                            </div>
                            <div class="textCenter">
                                <Loading :isLoading="isLoading"></Loading>
                            </div>
                            <div id="stopScroll"></div>
                            <Paginate :pageIndex="Page" :pageTotal="Math.ceil(total/PageSize)" @select="pageSelect"
                                      v-if="total>10">

                            </Paginate>
                        </div>
                        <div :class="isMapFixed?(isStopMapAndhs?'main-right float-active-stop':'main-right float-active'):'main-right'"
                             id="mapandhs">
                            <div class="map" v-if="mapPoints.length>0">
                                <MapView :mapCenter="mapCenter" :mapPoints="mapPoints" :showName='true' @select="mapSelect"></MapView>
                            </div>
                            <History></History>
                            <div class="clear"></div>

                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import ImgLoader from './../../common/cmpnt/imgLoader/imgLoader.vue'//图片异步加载+效果
    import CanvasScore from './../../common/cmpnt/CanvasScore/CanvasScore.vue'//评分图圈
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import DatePicker from './../../common/cmpnt/datePicker/datePicker.vue'//日期
    import SearchAll from './../../common/cmpnt/searchAll/SearchAll'//模糊搜索
    import SearchBox from './../../common/cmpnt/searchBox/searchBox'//搜索组件
    import History from './../../common/cmpnt/History/History.vue'//历史记录
    //导入设施设备匹配列表
    import eqmtList from './../../common/equitment.js'
    import MapView from './../../common/cmpnt/map/Map.vue'//地图
    import Paginate from './../../common/cmpnt/paginate/paginate.vue'//分页
    import coordtransform from 'coordtransform';//经纬度转为高德的标准

    export default {
        name: "hotelList",
        components: {
            ImgLoader,
            CanvasScore,
            Loading,
            DatePicker,
            History,
            SearchAll,
            SearchBox,
            Paginate,
            MapView
        },

        data() {
            return {
                Currency: this.dao.get('userInfo').Currency,
                RegionID: this.dao.get('hotelListSearchParams').RegionID,
                CityName: this.dao.get('hotelListSearchParams').CityName,
                MyCityRegionID: this.dao.get('hotelListSearchParams').MyCityRegionID || '',
                districtId: this.dao.get('hotelListSearchParams').districtId || '',
                ProductType: this.dao.get('hotelListSearchParams').ProductType || '4',
                From: Number(this.dao.get('hotelListSearchParams').From),
                Name: this.dao.get('hotelListSearchParams').Name,
                Landmark: this.dao.get('hotelListSearchParams').Landmark || '',
                LandmarkCode: this.dao.get('hotelListSearchParams').LandmarkCode || '',
                LandmarkName: this.dao.get('hotelListSearchParams').LandmarkName || '',
                Star: this.dao.get('hotelListSearchParams').Star || '',
                PriceMin: this.dao.get('hotelListSearchParams').PriceMin || '',
                PriceMax: this.dao.get('hotelListSearchParams').PriceMax || '',
                CheckIn: this.dao.get('hotelListSearchParams').CheckIn,
                CheckOut: this.dao.get('hotelListSearchParams').CheckOut,
                Country:this.dao.get('hotelListSearchParams').Country||{
                    "Code2": "CN",
                    "Code3": "CHN",
                    "Num": "156",
                    "Iso": "ISO 3166-2:CN",
                    "ENName": "China",
                    "CNName": "中国大陆"
                },
                RoomCount: Number(this.dao.get('hotelListSearchParams').RoomCount) || 1,
                AdultCount: Number(this.dao.get('hotelListSearchParams').AdultCount || 2),
                ChildrenCount: Number(this.dao.get('hotelListSearchParams').ChildrenCount || 0),
                Sort: this.dao.get('hotelListSearchParams').Sort || 0,
                HotelIDs: this.dao.get('hotelListSearchParams').HotelID || '',
                MyLat: this.dao.get('hotelListSearchParams').MyLat || '',
                MyLon: this.dao.get('hotelListSearchParams').MyLon || '',
                MyPositionLat: this.dao.get('hotelListSearchParams').MyPositionLat || '',
                MyPositionLon: this.dao.get('hotelListSearchParams').MyPositionLon || '',
                Radius: 4,
                ChildrenAges: [],
                Page: 1,
                PageSize: 10,
                FilterNOPrice: '',
                SupID: '',
                list: [],
                total: 0,
                eqmtList: eqmtList,
                mapPoints: [],//地图数据
                mapCenter: {},//地图中心
                dateToday: this.getDate(0),
                isLoading: false,
                mapAndHistoryFixed: false,
                isMapFixed:false,
                isStopMapAndhs: false,
                isRoomLoading: false,//加载房型价格缓冲
                isKeyResultShow: false,

                key: this.$route.query.lastKey||this.dao.get('hotelListSearchParams').key || '',
                LandmarkGroups: '',
                LgActive: '',
                calendar: {
                    show: false,
                    start: this.getDate(0),
                    begin: this.getDate(1),
                    end: this.getDate(2),
                    select: (begin, end) => {

                        if (!begin) {
                            this.calendar.show = false;
                            return;
                        }
                        this.calendar.begin = begin;
                        this.calendar.end = end;
                        this.CheckIn = begin;
                        this.CheckOut = end;
                        this.$nextTick(function () {
                            this.calendar.show = false;
                            // this.changeFilter();
                        });
                    }
                },
                starBoxShow: false,
                priceBoxShow: false,
                discountBoxShow:false,
                priceText: '价格',
                priceText1: '价格   低<i class="iconfont icon-qianjin"></i>高',
                priceText2: '价格   高<i class="iconfont icon-qianjin"></i>低'
            }
        },
        watch: {
            Sort(val) {
                this.changeFilter();
            },
            CityName(val) {
                document.title = '【' + val + '】' + val + '酒店查询,预定---订房易';
            }
        },
        methods: {
            //地标是否有对应的图标
            isIconExist(key) {
                var list = [1, 6, 7, 8, 9, 30, 32, 44, 47, 50, 55, 56, 68, 70, 76, 78, 100, 99];
                for (var i = 0; i < list.length; i++) {
                    if (list[i] == key) {
                        return true;
                        break;
                    }
                }
                return false;
            },
            // 选择页数
            pageSelect(val) {
                this.total = 0;
                this.list = [];
                this.Page = val;
                this.initData();
            },
            selectCountry(obj){
                this.Country = obj;
            },
            //选择间数
            selectRoomCount(val) {
                this.RoomCount = val;
            },
            //选中日期
            calendarSelect(begin, end) {
                this.CheckIn = begin;
                this.CheckOut = end;
            },
            //选择城市
            selectCity(city) {
                this.RegionID = city.ID;
                this.From = city.From;
                this.CityName = city.CName || city.SName;

                this.key = city.CName || city.SName;
                this.isKeyResultShow = false;

                this.LandmarkName = '';
                this.LandmarkCode = '';
                this.Name = '';
                this.changeFilter();
                this.getLandmarks();
            },
            //选择酒店
            selectHotel(hotel) {
                this.From = hotel.From;
                var obj = {
                    ID: hotel.HotelID
                }
                //查询酒店信息
                this.routeToDetails(obj);

            },
            //选择酒店
            selectRoomPeopelNum(Adult, Children, ages) {
                this.AdultCount = Number(Adult);
                this.ChildrenAges = ages;
                this.ChildrenCount = Number(Children);
            },
            //选择地标
            selectLandmark(landmark) {

                this.RegionID = landmark.CityID;
                this.CityName = landmark.City;
                this.LandmarkName = landmark.Name;
                this.LandmarkCode = landmark.ID;
                this.From = landmark.From;
                this.key = landmark.Name;

                this.Name = '';
                this.isKeyResultShow = false;
                this.changeFilter();
            },

            //选择当前城市的地标
            selectThisLandmark(landmark) {

                if (!landmark) {
                    this.LgActive = '';
                    this.LandmarkName = '';
                    this.LandmarkCode = '';
                } else {
                    this.LandmarkName = landmark.Name;
                    this.LandmarkCode = landmark.ID;
                }

            },
            // 展开所有房型
            showAllRooms(room) {
                this.$nextTick(function () {
                    this.$set(room, 'isShowAllRooms', room.isShowAllRooms ? false : true);
                });
            },
            //条件更新后重置参数和结果
            changeFilter($state) {
                this.Page = 1;
                this.total = 0;
                this.list = [];
                this.initData();
            },
            openPolicyShow(price) {
                this.$nextTick(function () {
                    this.$set(price, 'isPolicyShow', price.isPolicyShow ? false : true);
                });
            },
            openRoomShow(price) {
                this.$nextTick(function () {
                    this.$set(price, 'roomShow', price.roomShow ? false : true);
                });
            },
            // 展示更多房型
            showMoreRooms(price) {
                this.$nextTick(function () {
                    this.$set(price, 'showAllRooms', price.showAllRooms ? false : true);
                });
            },
            //打开详情
            routeToDetails(item) {
                var obj = {
                    CityName: this.CityName,
                    HotelID: item.ID,
                    From: this.From,
                    ProductType: this.ProductType,
                    CheckIn: this.CheckIn,
                    CheckOut: this.CheckOut,
                    RoomCount: this.RoomCount,
                    AdultCount: this.AdultCount,
                    ChildrenCount: this.ChildrenCount,
                    ChildrenAges: this.ChildrenAges,
                    MyLat: this.MyLat,
                    MyLon: this.MyLon,
                    RegionID: this.RegionID,
                    MyCityRegionID: this.MyCityRegionID,
                    Country:this.Country,
                }
                this.dao.set('hotelDetailsParams', obj)

                window.open('#/hotelDetails?lastKey='+this.key, '_blank');
                // this.$router.push('/hotelDetails')
            },

            //国内前往下单
            book(item, room, price) {
                var that = this;
                if (price.Tip > 1) {
                    that.error({title: '不能预订', content: price.Errors});
                    return;
                }
                var obj = {
                    From: that.From,
                    RegionID: that.RegionID,
                    HotelName: item.HotelName,
                    RoomName: room.RoomName,
                    RPName: price.RPName,
                    CheckIn: that.CheckIn,
                    CheckOut: that.CheckOut,
                    RoomCount: that.RoomCount,
                    AdultCount: that.AdultCount,
                    ChildrenAges: that.ChildrenAges,
                    Star: item.Star,
                    HotelAddress: item.Address,
                    HotelPhone: item.Phone,
                    AdultPrice: price.AdultPrice,
                    days: that.getDays(that.CheckIn, that.CheckOut),
                    Token: price.Token,
                    CancelPolicy: price.CancelPolicy,
                    Breakfast: price.Breakfast,
                    Currency: price.Currency,
                    Tip: price.Tip,
                    Stock: price.Stock,
                    MaxPerson: price.MaxPerson,
                    // Breakfast: price.Breakfast,
                    DailyRates: price.DailyRates,
                    IsAskRoom: price.IsAskRoom,
                    details: item,
                    room: room
                }

                that.dao.set('bookInfo', obj);
                //检查是否可以预订
                this.checkBookAble(price.Token, function () {
                    that.$router.push('/hotelBook');
                })
            },
            //海外前往下单
            frbook(item, price) {
                var that = this;
                if (price.Tip > 1) {
                    that.error({title: '不能预订', content: price.Errors});
                    return;
                }
                var obj = {
                    From: that.From,
                    RegionID: that.RegionID,
                    HotelName: item.HotelName,
                    RoomName: price.RoomName,
                    RPName: price.RPName,
                    CheckIn: that.CheckIn,
                    CheckOut: that.CheckOut,
                    RoomCount: that.RoomCount,
                    AdultCount: that.AdultCount,
                    ChildrenAges: that.ChildrenAges,
                    Star: item.Star,
                    HotelAddress: item.Address,
                    HotelPhone: item.Phone,
                    AdultPrice: price.AdultPrice,
                    days: that.getDays(that.CheckIn, that.CheckOut),
                    Token: price.Token,
                    CancelPolicy: price.CancelPolicy,
                    Breakfast: price.Breakfast,
                    Currency: price.Currency,
                    Tip: price.Tip,
                    Stock: price.Stock,
                    MaxPerson: price.MaxPerson,
                    // Breakfast: price.Breakfast,
                    DailyRates: price.DailyRates,
                    IsAskRoom: price.IsAskRoom,
                    details: item,
                    room: price
                }
                that.dao.set('bookInfo', obj);
                //检查是否可以预订
                this.checkBookAble(price.Token, function () {
                    that.$router.push('/hotelBook');
                })
            },
            // 检查是否可以预订
            checkBookAble(token, callback) {
                var that = this;
                that.isSubmit = true;
                var param = {
                    token: token
                }
                that.postRequest({
                    url: that.Api.checkBookable,
                    params: param
                }).then(res => {
                    that.isSubmit = false;
                    //当IsSuccess==true时，表示有库存可以预订
                    if (res) {
                        if (res.IsSuccess) {
                            callback();
                        } else {
                            this.error({title: '提示', content: res.Msg || '不能预订'});
                        }
                    }
                });
            },

            //查询酒店信息
            initData($state) {
                var that = this;
                that.isLoading = true;


                var params = {
                    RegionID: that.RegionID,
                    From: that.From,
                    ProductType: that.ProductType,
                    Name: that.Name,
                    Landmark: that.Landmark,
                    LandmarkCode: that.LandmarkCode,
                    StarsStr: that.Star == 5 ? '4,5' : that.Star,
                    PriceMin: that.PriceMin,
                    PriceMax: that.PriceMax,
                    CheckIn: that.CheckIn,
                    CheckOut: that.CheckOut,
                    RoomCount: that.RoomCount,
                    AdultCount: that.AdultCount,
                    ChildrenCount: that.ChildrenCount,
                    ChildrenAges: that.ChildrenAges,
                    Page: that.Page,
                    PageSize: that.PageSize,
                    HotelIDs: that.HotelIDs,
                    Sort: that.Sort,
                    MyLat: that.MyLat,
                    MyLon: that.MyLon,
                    Radius: that.Radius,
                    MyCityRegionID: that.MyCityRegionID,
                }

                that.postRequest({
                    url: that.Api.price,
                    params: params
                }).then(res => {
                    that.isLoading = false;
                    if (res && res.IsSuccess && res.Result.length > 0) {
                        that.total = res.Total;

                        that.list = res.Result;
                        that.setMapData(that.list);//设置地图数据
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }        
                        })
                    } else {
                        that.list = ''
                    }
                });
            },

            //批量加载房型
            loadTablesBath(list) {
                if (!list || list.length < 1) return;
                for (var i = 0; i < list.length; i++) {
                    this.loadTables(list[i]);
                }
            },
            //加载房型
            loadTables(item) {
                var that = this;
                that.$nextTick(function () {
                    that.$set(item, 'isShowAllRooms', item.isShowAllRooms ? false : true);

                });
                if (item.tables) return;
                var params = {
                    HotelID: item.ID,
                    ProductType: that.ProductType,
                    From: that.From,
                    CheckIn: that.CheckIn,
                    CheckOut: that.CheckOut,
                    RoomCount: that.RoomCount,
                    AdultCount: that.AdultCount,
                    ChildrenCount: that.ChildrenCount,
                    MyLat: that.MyLat,
                    MyLon: that.MyLon,
                    MyCityRegionID: that.MyCityRegionID,
                    CountryCode:that.Country.code2,
                }
                that.$nextTick(function () {
                    that.$set(item, 'isRoomLoading', true);
                });
                that.postRequest({
                    url: that.Api.getPrices,
                    params: params
                }).then(res => {
                    item.isRoomLoading = false;
                    if (res && res.IsSuccess) {
                        that.$nextTick(function () {
                            that.$set(item, 'tables', res.Result);
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }    
                        });
                        
                    } else {
                        that.$nextTick(function () {
                            that.$set(item, 'tables', '');
                        });
                    }

                });

            },
            //获取地标
            getLandmarks(item) {
                var that = this;
                var params = {
                    pid: that.RegionID,
                    page: 1,
                    pageSize: 100,
                }
                that.getRequest({
                    url: that.Api.getLandmarkGroups,
                    params: params
                }).then(res => {
                    if (res && res.IsSuccess) {
                        that.LandmarkGroups = res.Result;
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }          
                        })
                        // that.setLandmarkGroups(res.Result);
                    } else {
                        that.LandmarkGroups = '';
                    }
                });
            },
            //地图选中酒店跳转
            mapSelect(hotel) {
                console.log(hotel)
                // var obj = {
                //     ID: hotel.id
                // }
                // this.routeToDetails(obj);
            },
            //设置地图数据
            setMapData(list) {
                var option = [];
                for (var i = 0; i < list.length; i++) {
                    if (list[i].Lat && list[i].Lon) {
                        const [hotelLng, hotelLat] = coordtransform.bd09togcj02(+list[i].Lon, +list[i].Lat);
                        option.push({
                            lat: hotelLat,
                            lng: hotelLng,
                            name: list[i].HotelName,
                            id: list[i].ID
                        });
                    }
                }
                this.mapPoints = option;
                this.mapCenter = option[0];
            },
            //获取在当前窗口中的酒店
            getHotelInWindow(scrollTop) {
                var list = [];
                var height = window.screen.height;
                var minTop = scrollTop;
                var maxTop = scrollTop + height;
                var hotels = this.$refs;

                for (var item in hotels) {
                    if (hotels[item][0] && hotels[item][0].offsetTop && hotels[item][0].offsetTop > minTop && hotels[item][0].offsetTop < maxTop) {
                        const [hotelLng, hotelLat] = coordtransform.bd09togcj02(+hotels[item][0].dataset.lng, +hotels[item][0].dataset.lat);
                        var obj = {
                            name: hotels[item][0].dataset.name,
                            lat: hotelLat,
                            lng: hotelLng,
                            id: hotels[item][0].dataset.id,
                        }
                        list.push(obj);
                    }
                }
                this.mapPoints = list;
                this.mapCenter = list[0];
            },
            //处理屏幕滚动事件
            handleScroll(e) {

                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                var offsetTop = document.querySelector('#mapAndHistory') ? document.querySelector('#mapAndHistory').offsetTop : 0;
                var stopScrollTop = document.querySelector('#stopScroll') ? document.querySelector('#stopScroll').offsetTop : 0;
                var mapandhs = document.querySelector('#mapandhs');
                var clientHeight = document.body.clientHeight;
                if (scrollTop > offsetTop) {
                    if(scrollTop > 240){
                        if (scrollTop > stopScrollTop - 600) {
                            mapandhs.style.top = (stopScrollTop - 680) + 'px';
                            this.isStopMapAndhs = true;
                        } else{
                            mapandhs.style.top = '60px';
                            this.isStopMapAndhs = false;
                            this.isMapFixed = false;
                        }
                        this.isMapFixed = true;
                    }else{
                        this.isMapFixed = false;
                    }
                    this.mapAndHistoryFixed = true;
                    this.getHotelInWindow(scrollTop);
                } else {
                    this.mapAndHistoryFixed = false;
                    this.isMapFixed = false;
                }
            }
        },
        mounted() {
            document.title = '【' + (this.CityName || '') + '】' + (this.CityName || '') + '酒店查询,预定---订房易';
            this.initData();
            this.getLandmarks();
            // window.addEventListener('scroll', this.handleScroll)
            //给页面绑定滑轮滚动事件  Firefox
            if (document.addEventListener) {//firefox
                document.addEventListener('DOMMouseScroll', this.handleScroll, false);
            }
            //滚动滑轮触发scrollFunc方法 ie 谷歌
            window.onmousewheel = document.onmousewheel = this.handleScroll;

        },

        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        } ,
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/hotel/List.vue